import React from "react";
import bgImage from "../../assets/paymentSummaryBg.png";
import {
  formatAmountWithSymbol,
  squareKilometersToAcres,
} from "../../ReusableFunctions/reusableFunctions";
import { useSelector } from "react-redux";
export default function PaymentSummary({ invoice, request }) {
  const user = useSelector((state) => state.user.user);
  localStorage.setItem("request", request);
  let field_area =
    request?.price_by === "acre"
      ? squareKilometersToAcres(
          request?.service_completed_area || request?.field_area,
        )
      : request?.service_completed_area || request?.field_area;
  let per_acre_service_charge = request.invoice?.service_amount / field_area;
  // const invoiceCurrency =
  //   invoice?.invoice_currency || user?.dsp?.invoice_currency;
  const invoiceCurrency = request.invoice?.invoice_currency || user?.dsp?.invoice_currency;
  return (
    <div
      style={{ backgroundImage: `url(${bgImage})` }}
      className="w-full py-6 px-8 mt-4 min-h-[fit-content] "
    >
      <h3 className="font-manrope font-[700] text-[#1E1E1E]">
        Payment Details
      </h3>
      <div className="mt-2 flex flex-col gap-[8px]">
        <div className="flex justify-between">
          <span className="font-manrope font-[500] text-[15px]">
            Service Charges{" "}
            <span className="text-[#848484]">
              ({field_area} {request?.price_by === "acre" ? "Acres" : "Tanks"} X{" "}
              {formatAmountWithSymbol(
                per_acre_service_charge,
                user?.country_code,
                invoiceCurrency,
              )}{" "}
              per {request?.price_by === "acre" ? "Acre" : "Tank"} )
            </span>
          </span>
          <span className="font-manrope text-[#3B3B3B] text-[15px]">
            {invoice.service_amount
              ? formatAmountWithSymbol(
                  invoice.service_amount,
                  user?.country_code,
                  invoiceCurrency,
                )
              : "00"}
          </span>
        </div>
        {Number(invoice?.pesticides_subsidy) != 0 && (
          <div className="flex justify-between">
            <span className="font-manrope font-[500] text-[15px]">
              Total Subsidy{" "}
              <span className="text-[#848484]">
                ({field_area} {request?.price_by === "acre" ? "Acres" : "Tanks"}{" "}
                X{" "}
                {formatAmountWithSymbol(
                  request?.invoice?.pesticide_per_acre_subsidy,
                  user?.country_code,
                  invoiceCurrency,
                )}{" "}
                per {request?.price_by === "acre" ? "Acre" : "Tank"} )
              </span>
            </span>
            <span className="font-manrope text-[#32B338] text-[15px]">
              -
              {invoice?.pesticides_subsidy
                ? `${formatAmountWithSymbol(invoice?.pesticides_subsidy, user?.country_code, invoiceCurrency)}`
                : "00"}
            </span>
          </div>
        )}
        {Number(invoice.applied_dsp_coupon_total_amount) != 0 && (
          <div className="flex justify-between">
            <span className="font-manrope font-[500] text-[15px]">
              DSP Coupons{" "}
            </span>
            <span className="font-manrope text-[#32B338] text-[15px]">
              {invoice.applied_dsp_coupon_total_amount
                ? formatAmountWithSymbol(
                    invoice.applied_dsp_coupon_total_amount,
                    user?.country_code,
                    invoiceCurrency,
                  )
                : "00"}
            </span>
          </div>
        )}
        {Number(invoice.applied_bhumeet_coupon_total_amount) != 0 && (
          <div className="flex justify-between">
            <span className="font-manrope font-[500] text-[15px]">
              BhuMeet Coupons{" "}
            </span>
            <span className="font-manrope text-[#32B338] text-[15px]">
              -{" "}
              {invoice.applied_bhumeet_coupon_total_amount
                ? formatAmountWithSymbol(
                    invoice.applied_bhumeet_coupon_total_amount,
                    user?.country_code,
                    invoiceCurrency,
                  )
                : "00"}
            </span>
          </div>
        )}
        {Number(invoice.applied_csgt_amount) != 0 && (
          <div className="flex justify-between">
            <div className="flex gap-1">
              <span className="font-manrope font-[500] text-[15px]">cgst </span>
              {invoice?.cgst && (
                <span className="text-[#848484]">({invoice?.cgst}%)</span>
              )}
            </div>
            <span className="font-manrope text-[#32B338] text-[15px]">
              -{" "}
              {invoice.applied_csgt_amount
                ? formatAmountWithSymbol(
                    invoice.applied_csgt_amount,
                    user?.country_code,
                    invoiceCurrency,
                  )
                : "00"}
            </span>
          </div>
        )}
        {Number(invoice.applied_sgst_amount) != 0 && (
          <div className="flex justify-between">
            <div className="flex gap-1">
              <span className="font-manrope font-[500] text-[15px]">sgst </span>
              {invoice?.sgst && (
                <span className="text-[#848484]">({invoice?.sgst}%)</span>
              )}
            </div>
            <span className="font-manrope text-[#32B338] text-[15px]">
              -{" "}
              {invoice.applied_sgst_amount
                ? formatAmountWithSymbol(
                    invoice.applied_sgst_amount,
                    user?.country_code,
                    invoiceCurrency,
                  )
                : "00"}
            </span>
          </div>
        )}

        {Number(invoice.discount_amount) != 0 && (
          <div className="flex justify-between">
            <span className="font-manrope font-[500] text-[15px]">
              Discount{" "}
            </span>
            <span className="font-manrope text-[#32B338] text-[15px]">
              -{" "}
              {invoice.discount_amount
                ? formatAmountWithSymbol(
                    invoice.discount_amount,
                    user?.country_code,
                    invoiceCurrency,
                  )
                : "00"}
            </span>
          </div>
        )}
        {Number(invoice.total_tax_amount) != 0 && (
          <div className="flex justify-between">
            <div className="flex gap-1">
              <span className="font-manrope font-[500] text-[15px]">
                Tax Amount{" "}
              </span>
              {invoice?.tax && (
                <span className="text-[#848484]">({invoice?.tax}%)</span>
              )}
            </div>
            <span className="font-manrope text-[#1E1E1E] text-[15px]">
              +{" "}
              {invoice.total_tax_amount
                ? formatAmountWithSymbol(
                    invoice.total_tax_amount,
                    user?.country_code,
                    invoiceCurrency,
                  )
                : "00"}
            </span>
          </div>
        )}
        <div className="w-full my-1 h-[5px] border border-dotted border-b-[#BFC8D9]"></div>
        <div className="flex justify-between">
          <span className="font-manrope font-[500] text-[15px]">
            Total Amount{" "}
          </span>
          <span className="font-manrope text-[#1E1E1E] font-[700]  text-[15px]">
            {" "}
            {/* {invoice.total_amount
              ? formatAmountWithSymbol(
                  Number(invoice.total_amount) +
                    Number(invoice.total_tax_amount || 0),
                  user?.country_code,
                  invoiceCurrency,
                )
              : "00"}{" "} */}
            {invoice.total_amount
              ? formatAmountWithSymbol(
                  Number(invoice.total_amount),
                  user?.country_code,
                  invoiceCurrency,
                )
              : "00"}{" "}
          </span>
        </div>
      </div>
    </div>
  );
}
